(function(moment) {
    moment.fn.preciseDiff = function(d2, settings) {
        return moment.preciseDiff(this, d2, settings);
    };

    moment.preciseDiff = function(d1, d2, settings) {
        var m1 = moment(d1),
            m2 = moment(d2),
            locale = this.localeData();

        if (settings === parseInt(settings, 10)) {
            settings = {
                maxLength: settings
            };
        }

        settings = Object.assign({
            maxLength: 0,
            delimiter: ' ',
            lastPrefix: null
        }, settings);

        var order = [
            ['years', 'y', 'yy'],
            ['months', 'M', 'MM'],
            ['days', 'd', 'dd'],
            ['hours', 'h', 'hh'],
            ['minutes', 'm', 'mm'],
            ['seconds', 's']
        ];

        settings.maxLength = settings.maxLength || order.length;

        var parts = [];

        order.forEach(function(attr) {
            if (parts.length >= settings.maxLength) {
                return false;
            }

            var diff = m2.diff(m1, attr[0]);

            if (diff) {
                m1.add(diff, attr[0]);

                var string = locale.relativeTime(diff, true, diff <= 1 ? attr[1] : (attr[2] || attr[1]));

                if (settings.lastPrefix && (settings.maxLength - 1) === parts.length) {
                    string = settings.lastPrefix + string;
                }

                parts.push(string);
            }
        });

        return parts.join(settings.delimiter);
    };
}(moment));